/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateUserEmailMarketingAgreedRequestUser } from './UpdateUserEmailMarketingAgreedRequestUser';
import {
    UpdateUserEmailMarketingAgreedRequestUserFromJSON,
    UpdateUserEmailMarketingAgreedRequestUserFromJSONTyped,
    UpdateUserEmailMarketingAgreedRequestUserToJSON,
} from './UpdateUserEmailMarketingAgreedRequestUser';

/**
 * 
 * @export
 * @interface UpdateUserEmailMarketingAgreedRequest
 */
export interface UpdateUserEmailMarketingAgreedRequest {
    /**
     * 
     * @type {UpdateUserEmailMarketingAgreedRequestUser}
     * @memberof UpdateUserEmailMarketingAgreedRequest
     */
    user: UpdateUserEmailMarketingAgreedRequestUser;
}

/**
 * Check if a given object implements the UpdateUserEmailMarketingAgreedRequest interface.
 */
export function instanceOfUpdateUserEmailMarketingAgreedRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user" in value;

    return isInstance;
}

export function UpdateUserEmailMarketingAgreedRequestFromJSON(json: any): UpdateUserEmailMarketingAgreedRequest {
    return UpdateUserEmailMarketingAgreedRequestFromJSONTyped(json, false);
}

export function UpdateUserEmailMarketingAgreedRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserEmailMarketingAgreedRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': UpdateUserEmailMarketingAgreedRequestUserFromJSON(json['user']),
    };
}

export function UpdateUserEmailMarketingAgreedRequestToJSON(value?: UpdateUserEmailMarketingAgreedRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': UpdateUserEmailMarketingAgreedRequestUserToJSON(value.user),
    };
}

